export type Ecc = "L" | "M" | "Q" | "H";

export interface EccLevel {
	id: Ecc;
	/** Approximate share of the symbol that can be damaged and still scan. */
	recovery: string;
	/** Byte-mode capacity of a version-40 symbol (ISO/IEC 18004). */
	byteCapacity: number;
}

export const ECC_LEVELS: readonly EccLevel[] = [
	{ id: "L", recovery: "7%", byteCapacity: 2953 },
	{ id: "M", recovery: "15%", byteCapacity: 2331 },
	{ id: "Q", recovery: "25%", byteCapacity: 1663 },
	{ id: "H", recovery: "30%", byteCapacity: 1273 },
];

export function eccLevel(id: Ecc): EccLevel {
	const found = ECC_LEVELS.find((l) => l.id === id);
	if (!found) throw new Error(`Unknown ECC level: ${id}`);
	return found;
}

export function isEcc(value: unknown): value is Ecc {
	return value === "L" || value === "M" || value === "Q" || value === "H";
}

/** UTF-8 byte length of a string. Emoji and other astral characters count as 4. */
export function utf8ByteLength(text: string): number {
	return new TextEncoder().encode(text).length;
}

/**
 * Whether the text definitely exceeds what any QR code can hold in byte mode.
 * The encoder may still fit more numeric/alphanumeric data than this by using
 * other modes, so `false` here is not a guarantee; the encoder has the last word.
 */
export function exceedsByteCapacity(text: string, ecc: Ecc): boolean {
	return utf8ByteLength(text) > eccLevel(ecc).byteCapacity;
}
